import { createContext, useContext } from "react";

const AppContext = createContext({
	peakConfigs: {},
	promoBanner: null,
	isMobile: false,
});

export const AppProvider = ({ children, value }) => {
	return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useAppContext = () => useContext(AppContext);
